import { Col } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const OtherSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const lymphNodeSwellingLabel = t(
    'epidemiology.symptoms.other.lymphNodeSwelling'
  )

  return (
    <>
      <Col span={24}>
        <Text>
          {`9. ${t('epidemiology.other')}`}:{' '}
          <Text weight={400}>
            {t(`epidemiology.symptoms.general.${symptoms.other?.status}`)}
          </Text>
        </Text>
      </Col>

      {symptoms.other?.status === 'yes' && (
        <>
          {symptoms.other.lymphNodeSwelling?.isSelected && (
            <>
              <Col span={8}>
                <Text>{lymphNodeSwellingLabel}</Text>
              </Col>

              {symptoms.other?.lymphNodeSwelling.occipitalLymphNodes
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {lymphNodeSwellingLabel} -{' '}
                    {t('epidemiology.symptoms.other.occipitalLymphNodes')}
                  </Text>
                </Col>
              )}

              {symptoms.other?.lymphNodeSwelling.submandibularLymphNodes
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {lymphNodeSwellingLabel} -{' '}
                    {t('epidemiology.symptoms.other.submandibularLymphNodes')}
                  </Text>
                </Col>
              )}

              {symptoms.other?.lymphNodeSwelling.axillaryLymphNodes
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {lymphNodeSwellingLabel} -{' '}
                    {t('epidemiology.symptoms.other.axillaryLymphNodes')}
                  </Text>
                </Col>
              )}
            </>
          )}

          {symptoms.other.salivaryGlandSwelling?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.other.salivaryGlandSwelling')}
              </Text>
            </Col>
          )}

          {symptoms.other.other?.isSelected && (
            <>
              <Col span={8}>
                <Text>
                  {t('epidemiology.symptoms.other.otherSymptom')}
                  {symptoms.other.other.specify?.value &&
                    ` - ${symptoms.other.other.specify.value}`}
                </Text>
              </Col>
            </>
          )}
        </>
      )}
    </>
  )
}
